const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const InvoiceProcess = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'INVOICE_PROCESS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'INVOICE_PROCESS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default InvoiceProcess;